import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import emailVerifyDark from "../../images/oc-email-verification-dark.svg";
import emailVerifyLight from "../../images/oc-email-verification.svg";
import axiosInstance from "../../utils/Requests/axios";
import LanguageContext from "../../utils/Contexts/LanguageContext";

function Verified() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);
  const [isSuccess, setIsSuccess] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState(
    t("Verifying email...")
  );

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        await axiosInstance.get(`auth/verify/${token}`);
        setVerificationStatus(t("Email verified successfully!"));
        setIsSuccess(true);
      } catch (error) {
        setVerificationStatus("Invalid verification link.");
        setIsSuccess(false);
      }
    };
    verifyEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div
      className="w-100 content-space-t-4 content-space-t-lg-2 content-space-b-1"
      style={{ maxWidth: "25rem" }}
    >
      <div className="text-center">
        <div className="mb-4">
          <img
            className="avatar avatar-xxl avatar-4x3"
            src={emailVerifyLight}
            alt="Email Verification Light"
            data-hs-theme-appearance="default"
          />
          <img
            className="avatar avatar-xxl avatar-4x3"
            src={emailVerifyDark}
            alt="Email Verification Dark"
            data-hs-theme-appearance="dark"
          />
        </div>
        <div className={`btn disabled ${isSuccess ? "btn-success" : "btn-danger"}`} style={{ opacity: '1', width: '100%' }}>
          <p className="mb-1">{verificationStatus}</p>
        </div>
        <h1 className="display-5 mt-4">{t("Verifying email")}</h1>
        <div className="mt-4 mb-3" style={{ cursor: 'pointer' }} onClick={() => navigate("/sign-in")}>
          <p>{t("Skip now")}</p>
        </div>
      </div>
    </div>
  );
}

export default Verified;
